import { render, staticRenderFns } from "./changeCardMgt.vue?vue&type=template&id=0507f0fc&"
import script from "./changeCardMgt.vue?vue&type=script&lang=js&"
export * from "./changeCardMgt.vue?vue&type=script&lang=js&"
import style0 from "./changeCardMgt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports